import { render, staticRenderFns } from "./StockistPackagePayment.vue?vue&type=template&id=ab8a31e4"
import script from "./StockistPackagePayment.vue?vue&type=script&lang=js"
export * from "./StockistPackagePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports